import * as blink from './js/banner/blink';
import * as styles from './js/banner/styles';

export default { ...blink, ...styles };
